export const DAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
export const DAY_LABELS = { mon: "Segunda", tue: "Terça", wed: "Quarta", thu: "Quinta", fri: "Sexta", sat: "Sábado", sun: "Domingo" };
const SHORT = { mon: "seg", tue: "ter", wed: "qua", thu: "qui", fri: "sex", sat: "sáb", sun: "dom" };

const toMin = (hhmm) => { const [h, m] = (hhmm || "0:0").split(":").map(Number); return h * 60 + (m || 0); };

function nowIn(tz) {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: tz, weekday: "short", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const dayIdx = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
  const y = Number(get("year")), m = Number(get("month")), d = Number(get("day"));
  return { dayIdx, minutes: (Number(get("hour")) % 24) * 60 + Number(get("minute")), y, m, d };
}

const isoOffset = (now, i) => {
  const dt = new Date(Date.UTC(now.y, now.m - 1, now.d + i));
  return dt.toISOString().slice(0, 10);
};

export function getSupportStatus(settings) {
  if (!settings) return { online: true, label: "Online agora" };
  if (settings.always_open) return { online: true, label: "Online 24h" };
  const hours = settings.hours || {};
  const closures = Object.fromEntries((settings.closures || []).map((c) => [c.date, c.label || "Fechado"]));
  let tz = settings.timezone || "America/Sao_Paulo";
  let now;
  try { now = nowIn(tz); } catch { tz = "America/Sao_Paulo"; now = nowIn(tz); }
  const todayIso = isoOffset(now, 0);
  const today = hours[DAYS[now.dayIdx]];
  if (!closures[todayIso] && today?.enabled && now.minutes >= toMin(today.open) && now.minutes < toMin(today.close)) {
    return { online: true, label: `Online agora · até ${today.close}` };
  }
  const reason = closures[todayIso] ? `Hoje: ${closures[todayIso]}. ` : "";
  for (let i = 0; i < 14; i++) {
    const idx = (now.dayIdx + i) % 7;
    const d = hours[DAYS[idx]];
    if (!d?.enabled || closures[isoOffset(now, i)]) continue;
    if (i === 0 && now.minutes >= toMin(d.open)) continue;
    const when = i === 0 ? "hoje" : i === 1 ? "amanhã" : i < 7 ? SHORT[DAYS[idx]] : isoOffset(now, i).slice(8, 10) + "/" + isoOffset(now, i).slice(5, 7);
    return { online: false, label: `${reason}Volta ${when} às ${d.open}`, closed: !!closures[todayIso] };
  }
  return { online: false, label: `${reason}Deixe sua mensagem`, closed: !!closures[todayIso] };
}
